import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgJobPerFileIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="job_per_file_svg__nc-icon-wrapper">
      <path data-color="color-2" d="M45 1.586V13h11.414z" />
      <path d="M44 15a1 1 0 0 1-1-1V1H9a2 2 0 0 0-2 2v58a2 2 0 0 0 2 2h46a2 2 0 0 0 2-2V15H44zm-4 18h-7v7a1 1 0 1 1-2 0v-7h-7a1 1 0 1 1 0-2h7v-7a1 1 0 1 1 2 0v7h7a1 1 0 1 1 0 2z" />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgJobPerFileStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgJobPerFileIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const JobPerFileIcon: any = SvgJobPerFileStyle;
export default JobPerFileIcon;
